// src/components/UnderConstruction.js
//
// SECTION 542 (2026-09-30). Bob: "a large banner saying UNDER CONSTRUCTION" on the War Room, then "Any modules /
// tabs / pages that are Empty should have" it. Shown on the War Room always (it is being rebuilt) and on a page
// only while that page has nothing in it; it goes away by itself the moment there is content. The line under it
// says plainly why the page is empty - nothing is claimed that is not so.
import React from 'react';

export default function UnderConstruction({ note }) {
  return (
    <div role="status" style={{ background: 'repeating-linear-gradient(45deg, #E8A020 0 22px, #111 22px 44px)', padding: 6, borderRadius: 10, margin: '0 0 20px' }}>
      <div style={{ background: '#111', borderRadius: 6, padding: '22px 16px', textAlign: 'center' }}>
        <div style={{ fontSize: 'clamp(26px, 5vw, 44px)', fontWeight: 900, letterSpacing: 6, color: '#E8A020', lineHeight: 1.1 }}>UNDER CONSTRUCTION</div>
        {note ? <div style={{ fontSize: 14, color: '#DCE7F2', marginTop: 8 }}>{note}</div> : null}
      </div>
    </div>
  );
}
